<template>
  <div class="form-line">
    <div class="form-field form-field-radio-extended" v-if="prices.total" >
        <label>Payment Method</label>
        <div v-if="loaded">
            <div v-if="canUseBalancePayment" class="radio-option">
              <input v-model="item.payment_method" type="radio" value="team-balance">
              <div class="radio-label">
                  <h5>Team Balance <span style="font-weight: normal;" v-if="team.total_available">({{ team.total_available | toCurrency }} available)</span></h5>
                  <p>Use Your team's shared account balance to pay.</p>
              </div>
            </div>

            <div v-if="canUseCardPayment" class="radio-option" :class="{disabled: platform == 'gifting' && type == 'link'}">
              <input v-model="item.payment_method" type="radio" value="stripe" :disabled="platform == 'gifting' && type == 'link'">
              <div class="radio-label">
                  <h5>Credit / Debit Payment Card</h5>
                  <p>Use one of your saved credit or debit payment cards, or add a new card, to <span v-if="platform === 'top-up'">get topped up instantly</span><span v-else>pay directly</span>.</p>
                  
                  <div v-if="platform == 'gifting' && type == 'link'" class="small-note warning" style="margin-top: 5px;">
                     Card payments can not be used for link generation in the gifting section, only at the <a href="/pro/marketplace">Marketplace</a>.
                  </div>
                  
                  <div v-else-if="item.payment_method=='stripe'">
                      <select v-if="stripePaymentMethods.length" v-model="item.payment_method_id" style="margin: 5px 0 15px">
                          <option v-for="item in stripePaymentMethods" :value="item.id">{{ item.card_brand | toUpperCase }} ending in {{ item.last4 }}</option>
                      </select>

                      <div v-if="!stripePaymentMethods.length" class="small-note warning" style="margin-top: 10px">
                          <b>You don't have any payment cards saved on your profile.</b> Click the button below to add a new payment method.</b>
                      </div>
                      
                      <div @click="addPaymentMethod" class="ws-button small" style="float: left;">Add New Payment Card</div>
                  </div>
              </div>
            </div>

            <div v-if="canUseBankPayment" class="radio-option">
              <input v-model="item.payment_method" type="radio" value="bank-transfer">
              <div class="radio-label">
                  <h5>Bank Transfer</span></h5>
                  <p>Receive an invoice from us and get topped up manually after we receive your payment.</p>
              </div>
            </div>

            <div v-if="!canUseBalancePayment && !canUseCardPayment && !canUseBankPayment" class="small-note error">
                <b>You don't have access to any payment menthods.</b> You need to contact your <i>Team Manager</i> to enable you some payment methods to continue.
            </div>
        </div>
        <div v-else>
            <div class="ws-form-processing"><div class="value-loader"></div><p>Loading available payment methods...</p></div>
        </div>
    </div>
    <div class="form-field" v-else>
        <div class="small-note">Since the total price of this gift registration at the moment is zero, you can continue with your registration without payment.</div>
    </div>
    
    <payment-method-modal v-if="modals.paymentMethodModal" @added="paymentMethodAdded"></payment-method-modal>
  </div>
</template>


<script>
import PaymentMethodModal from '@/components/modals/PaymentMethodModal';

export default {
    name: "FieldNotecard",
    components: {PaymentMethodModal},
    props: [ 'item', 'platform', 'type', 'prices' ],
    data() {
        return {
            loaded: false,
        }
    },
    methods: {
        async fetchData() {
            if (!this.demo.isDemo && this.user.permissions && this.user.permissions.includes('use-cards')) {
                if (this.platform == 'gifting' && this.type == 'link') {
                    this.loaded = true;
                    return;
                }
                if (!this.user.permissions.includes('use-balance')) this.item.payment_method = 'stripe';
                if (!this.user.permissions.includes('use-cards') && this.canUseBankPayment()) this.item.payment_method = 'bank-transfer';
                if (this.team.corporation_id==5 && this.platform == 'marketplace') this.item.payment_method = 'stripe';
                if (this.team.plan!='pro') this.item.payment_method = 'stripe';
                
                await this.dispatchWaitAndNotify('fetchStripePaymentMethods', null, false, true);
                if (this.stripePaymentMethods.length) {
                    for (let i=0;i!=this.stripePaymentMethods.length;i++) {
                        if (this.stripePaymentMethods[i].preferred) this.item.payment_method_id = this.stripePaymentMethods[i].id;
                    }
                }
            }
            this.loaded = true;
            this.$emit('loaded');
        },
        addPaymentMethod() {
            this.modals.paymentMethodModal = true;
        },
        async paymentMethodAdded(id) {
            await this.dispatchWaitAndNotify('fetchStripePaymentMethods', null, false, true);
            this.item.payment_method_id = id;
            this.modals.paymentMethodModal = false;
        }
    },
    mounted() {
		this.fetchData();
	},
    computed: {
        demo() {
            return this.$store.state.demo;
        },
        modals() {
            return this.$store.state.modals;
        },
		team() {
			return this.$store.state.team.detail;
		},
        user() {
            return this.$store.state.currentUser;
        },
        stripePaymentMethods() {
            return this.$store.state.transaction.stripePaymentMethods;
        },
        canUseBalancePayment() {
            if (this.team.plan!='pro') return false;
            if (this.team.corporation_id==5 && this.platform == 'marketplace') return false;
            return this.user.permissions && this.user.permissions.includes('use-balance') && this.platform !== 'top-up';
        },
        canUseCardPayment() {
            if (this.demo.isDemo) return false;
            return this.user.permissions && this.user.permissions.includes('use-cards');
        },
        canUseBankPayment() {
            return this.user.permissions && this.user.permissions.includes('use-balance') && this.platform === 'top-up';
        }
    },
}
</script>